import HttpError from './HttpError';

export default class CouponInvalidError extends HttpError {}
